(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Environment', Environment);

    Environment.$inject = ['$resource'];

    function Environment ($resource) {
        var resourceUrl =  'api/environments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
